//#region Dependencias
import config from "../config";
import React, { Component } from "react";
import "../css/dataTables.css";
import $ from "jquery";
import moment from "moment";
import StandardSelectModal from "./StandardSelectModal";
import SuggestionList from "./SuggestionList";
import { Forecast, ForecastLine } from "./NewOrder";
import WarningModal from "./WarningModal";
import SuggestionsList from "./SuggestionsList";
//#endregion

//#region Variables globales
const itemsHeaders = [
    { title: "Artículo", value: true, filter: true, field: "ItemCode", format: null, classes: "text-left" },
    { title: "Descripción", value: true, filter: true, field: "ItemName", format: null, classes: "text-left" },
    { title: "Grupo", value: true, filter: true, field: "ItmsGrpNam", format: null, classes: "text-left" },
];

const whsHeaders = [
    { title: "Código", value: true, filter: true, field: "WhsCode", format: null, classes: "text-left" },
    { title: "Nombre", value: true, filter: true, field: "WhsName", format: null, classes: "text-left" },
];
//#endregion

class CreateForecastModal extends Component {
    //#region Acciones del componente
    constructor(props) {
        super(props);
        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            editMode: false,
            searchItem: "",
            showItemsModal: false,

            updateLine: -1,
            predictionsAction: "",
            showPredictionsList: false,
            predictions: [],

            showWarningModal: false,
            warningModel: {
                size: "modal-md",
                cancel: () => {},
            },

            recoveryModel: new Forecast(),
            inputRef: null,
        };
    }

    componentDidMount = async () => {
        const bodyModal = document.getElementById('bodyModal');
        if (bodyModal) { bodyModal.addEventListener('scroll', () => { this.setState({ showPredictionsList: false, predictions: [] }) }); }
    }

    closeModal = () => {
        $("#createForecastModal").modal("hide");
    };

    openItemsModal = async () => {
        await this.setState({
            showItemsModal: true,
            showPredictionsList: false,
            predictions: [],
        });
        $("#selectItemsModal").modal("show");
        $("#selectItemsModal").on("hidden.bs.modal", async () => { await this.setState({ showItemsModal: false }); });
    }

    openWhsModal = async (index = -1) => {
        if (index === -1) return;

        await this.setState({
            updateLine: index,
            showWhsModal: true,
            showPredictionsList: false,
            predictions: [],
        });
        $("#selectWhsModal").modal("show");
        $("#selectWhsModal").on("hidden.bs.modal", async () => { await this.setState({ updateLine: -1, showWhsModal: false }); });
    }

    editMode = async () => {
        const { model } = this.props;
        const recoveryModel = JSON.parse(JSON.stringify(model));

        await this.setState({
            editMode: true,
            recoveryModel
        });
    }

    cancelEditMode = async () => {
        const { model, updateModel } = this.props;
        const { recoveryModel } = this.state;
        if (model.hasChanges) { updateModel(recoveryModel); }
        await this.setState({
            editMode: false,
            recoveryModel: new Forecast(),
        });
    }

    showWarningModal = async (acceptAction) => {
        const { warningModel } = this.state;
        const { action } = this.props;

        warningModel.title = action === 1 ? "Crear Previsión" : "Guardar Cambios";
        warningModel.accept = acceptAction;

        await this.setState({
            showWarningModal: true,
            warningModel,
        });
        $("#warningModal").modal("show");
        $("#warningModal").on("hidden.bs.modal", async () => {
            warningModel.accept = null;
            warningModel.title = null;
            await this.setState({
                showWarningModal: false,
                warningModel,
            });
        });
    }
    //#endregion

    //#region Acciones del documento
    validateModel = () => {
        const { model, enableSpinner, showAlert, whsList, createForecast, updateForecast, action } = this.props;
        let  error = null;

        enableSpinner(true);
        if (!model.ForecastCode || model.ForecastCode?.trim() === "") { error = {type: "warning", message:"No se ha ingresado un Código para el pronostico"} }
        else if (model.ForecastCode.length > 16) { error = {type: "warning", message:"El código no puede ser mayor de 16 caracteres"} }
        else if (!model.ForecastName || model.ForecastName?.trim() === "") { error = {type: "warning", message:"No se ha ingresado un Nombre para el pronostico"} }
        else if (model.ForecastName.length > 100) { error = {type: "warning", message:"El nombre no puede ser mayor de 100 caracteres"} }
        else if (!model.SalesForecastLines || model.SalesForecastLines?.length === 0) { error = {type: "warning", message:"No se han ingresado Artículos al pronostico"} }
        else {
            const idLines = new Set();
            for (let i = 0; i < model.SalesForecastLines.length; i++) {
                const currentLine = model.SalesForecastLines[i];
                const idLine = `${currentLine.ItemNo}-${currentLine.Warehouse}`;
                if (!whsList.find(({WhsCode}) => WhsCode === currentLine.Warehouse)) { error = {type: "warning", message: `Ingrese un almacén valido para el articulo "${currentLine.ItemNo}": Linea ${i + 1}`} }

                if (idLines.has(idLine)) { error = {type: "warning", message: `El articulo "${currentLine.ItemNo}": Linea ${i + 1}, ya se encuentra agregada con el mismo almacén. Seleccione otro almacén o elimine la linea duplicada.`}; }
                else { idLines.add(idLine); }

                if (error) break;
            }
        }
        enableSpinner(false);

        if (!error) {
            if (action === 1) { this.showWarningModal(createForecast); }
            else {
                this.showWarningModal( async () => {
                    const result = await updateForecast();
                    if (result) {
                        await this.setState({
                            editMode: false,
                            recoveryModel: new Forecast(),
                        });
                    }
                });
            }
        }
        else { showAlert(error); }
    }
    //#endregion

    //#region Change fields
    //#region Nivel Cabecera
    changeStandardField = async (field, value, updateTimeInterval = false) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux[field] = value;
        await updateModel(modelAux, updateTimeInterval);
    }

    changeDateField = async (type = 1, value = "", input) => {
        const { updateModel, model, showAlert } = this.props;
        if (!value) {
            input.focus();
            return showAlert({ type: "warning", message: "Ingrese una fecha valida" });
        }
        let modelAux = Object.assign({}, model);
        const viewType = model.View || "M";
        const dateParams = value.split('-');
        let date = new Date(dateParams[0], dateParams[1] - 1, dateParams[2]);
        let updateTimeInterval = false;

        if (type === 1) {
            const endDateParams = modelAux.ForecastEndDate.split('-');
            let endDate = new Date(endDateParams[0], endDateParams[1] - 1, endDateParams[2]);
            if (date > endDate) {
                input.focus();
                return showAlert({ type: "warning", message: "La fecha de inicio no puede ser mayor a la fecha final" });
            }

            if (viewType === "M") { date.setDate(1); } // Ajustar el dia al primero del mes
            else if (viewType === "W") { while (date.getDay() !== 1) { date.setDate(date.getDate() - 1); } } // Ajustar el dia al Lunes de esa semana

            modelAux.ForecastStartDate = moment(date).format("YYYY-MM-DD");
            if (modelAux.ForecastStartDate !== modelAux.PrevStartDate) {
                modelAux.PrevStartDate = moment(date).format("YYYY-MM-DD");
                updateTimeInterval = true;
            }
        } else {
            const startDateParams = modelAux.ForecastStartDate.split('-');
            let startDate = new Date(startDateParams[0], startDateParams[1] - 1, startDateParams[2]);
            if (startDate > date) {
                input.focus();
                return showAlert({ type: "warning", message: "La fecha final no puede ser menor a la fecha de inicio" });
            }

            if (viewType === "M") {
                date = new Date(date.getFullYear(), date.getMonth() + 1, 1); // Ajustar el dia al primero del siguiente mes
                date.setDate(date.getDate() - 1); // Regresar un día para tener el ultimo del
            }
            else if (viewType === "W") { while (date.getDay() !== 0) { date.setDate(date.getDate() + 1); } } // Ajustar el dia al Lunes de esa semana

            modelAux.ForecastEndDate = moment(date).format("YYYY-MM-DD");
            if (modelAux.ForecastEndDate !== modelAux.PrevEndDate) {
                modelAux.PrevEndDate = moment(date).format("YYYY-MM-DD");
                updateTimeInterval = true;
            }
        }
        await updateModel(modelAux, updateTimeInterval);
    }

    changeTypeView = async (value) => {
        const { updateModel, model } = this.props;

        const startDateParams = model.ForecastStartDate.split('-');
        const endDateParams = model.ForecastEndDate.split('-');
        let startDate = new Date(startDateParams[0], startDateParams[1] - 1, startDateParams[2]);
        let endDate = new Date(endDateParams[0], endDateParams[1] - 1, endDateParams[2]);

        let modelAux = Object.assign({}, model);

        if (value === "M") {
            startDate.setDate(1); // Ajustar el dia al primero del mes
            endDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1); // Ajustar el dia al primero del siguiente mes
            endDate.setDate(endDate.getDate() - 1); // Regresar un día para tener el ultimo del
        } else if (value === "W") {
            while (startDate.getDay() !== 1) { startDate.setDate(startDate.getDate() - 1); } // Ajustar el dia al Lunes de esa semana
            while (endDate.getDay() !== 0) { endDate.setDate(endDate.getDate() + 1); } // Ajustar el dia al Lunes de esa semana
        }

        modelAux.View = value;
        modelAux.ForecastStartDate = moment(startDate).format("YYYY-MM-DD");
        modelAux.ForecastEndDate = moment(endDate).format("YYYY-MM-DD");

        modelAux.PrevForecastStartDate = moment(startDate).format("YYYY-MM-DD");
        modelAux.EndForecastEndDate = moment(endDate).format("YYYY-MM-DD");

        updateModel(modelAux, true);
    }
    //#endregion

    //#region Nivel linea
    changeSearchItem = async (value = "") => {
        const { itemsList } = this.props;
        let predictions = [];

        if (value.trim() !== "" && Array.isArray(itemsList)) {
            let searchTokens = value.toLowerCase().split(" ");
            predictions = itemsList.filter(record => {
                let tokens = (record?.ItemCode + " " + record?.ItemName + " " + record?.ItmsGrpNam).toLowerCase().split(" ");
                return searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token)));
            }).slice(0, 30);
        }

        await this.setState({
            predictionsAction: "items",
            showPredictionsList: predictions.length > 0 ? true : false,
            predictions,
            searchItem: value,
        })

        this.updateSuggestionsPosition("itemDocumentSearch", -5);
    }

    updateSuggestionsPosition = (input = "") => {
        const inputField = document.getElementById(input);
        const modalElement = document.getElementById("modal-content");


        if (!inputField || !modalElement) {
            this.setState({
                showPredictionsList: false,
                predictions: [],
                inputRef: null,
            })
            return;
        }
        let inputComponent = inputField.getBoundingClientRect();
        let modalComponent = modalElement.getBoundingClientRect();
        const inputRef = {
            bottom: (inputComponent.bottom || 0) + (25) - (modalComponent.top || 0),
            left: inputComponent.left,
        }

        this.setState({ inputRef });
    };

    addRow = async (selectedItem) => {
        const { updateModel, model, itemsList, showAlert } = this.props;
        const { _user } = this.state;
        const defaultWhs = _user?.DefaultWhs || _user?.Branch?.ProjectCode || "";
        const TimeInterval = JSON.parse(JSON.stringify(model)).TimeInterval;
        let modelAux = Object.assign({}, model);

        if (!selectedItem.ItemCode) {
            selectedItem = itemsList.find(({ ItemCode }) => ItemCode === selectedItem);
        }

        let newLine = new ForecastLine();
        newLine.ItemNo = selectedItem.ItemCode || "";
        newLine.ItemDescription = selectedItem.ItemName || "";
        newLine.Warehouse = defaultWhs;
        newLine.TimeInterval = TimeInterval;

        
        const existLine = modelAux.SalesForecastLines.find(({ ItemNo, Warehouse}) => ItemNo === newLine.ItemNo && Warehouse === newLine.Warehouse);
        if (existLine) { showAlert({ type: "info", message: `El artículo ya esta agregado en el documento. Linea: ${modelAux.SalesForecastLines.indexOf(existLine) + 1}` }); }

        modelAux.SalesForecastLines.push(newLine);
        await updateModel(modelAux);
        await this.setState({ searchItem: "" })
        $("#selectItemsModal").modal("hide");
    }

    removeRow = async(index = -1) => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        modelAux.SalesForecastLines.splice(index, 1);
        await updateModel(modelAux);
    }

    changeWhsLine = async (index = -1, value = "") => {
        const { whsList, updateModel, model } = this.props;
        if (index === -1) return;

        let modelAux = Object.assign({}, model);
        let line = modelAux.SalesForecastLines[index];
        let predictions = [];

        if (value.trim() !== "" && Array.isArray(whsList)) {
            let searchTokens = value.toLowerCase().split(" ");
            predictions = whsList.filter(record => {
                let tokens = (record?.WhsCode + " " + record?.WhsName).toLowerCase().split(" ");
                return searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token)));
            }).slice(0, 30);
        }

        await this.setState({
            updateLine: index,
            predictionsAction: "whs",
            showPredictionsList: predictions.length > 0 ? true : false,
            predictions,
        })

        line.Warehouse = value;
        await updateModel(modelAux);

        this.updateSuggestionsPosition("inputWhs-" + index, -5);
    }

    selectWhs = async (selectedWhs) => {
        const { updateModel, model, whsList } = this.props;
        const { updateLine } = this.state;
        let modelAux = Object.assign({}, model);
        let line = modelAux.SalesForecastLines[updateLine];

        if (!selectedWhs.WhsCode) { selectedWhs = whsList.find(({ WhsCode }) => WhsCode === selectedWhs); }
        line.Warehouse = selectedWhs.WhsCode;
        await updateModel(modelAux);
        $("#selectWhsModal").modal("hide");
    }

    changeQty = async (lineIndex, intervalIndex, value = "") => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        let line = modelAux.SalesForecastLines[lineIndex];
        let interval = line.TimeInterval[intervalIndex];
        if (value.trim() === ".") { value = "0." }
        if (!isNaN(value)) { interval.Quantity = value.trim(); }
        await updateModel(modelAux);
    }

    validateQty = async (lineIndex, intervalIndex, value = "") => {
        const { updateModel, model } = this.props;
        let modelAux = Object.assign({}, model);
        let line = modelAux.SalesForecastLines[lineIndex];
        let interval = line.TimeInterval[intervalIndex];

        interval.Quantity = Number(value || 0).toFixed(3);

        await updateModel(modelAux);
    }
    //#endregion
    //#endregion

    //#region Render
    renderHeader = () => {
        const {
            action,
            model
        } = this.props;

        const {
            editMode
        } = this.state;

        return (
            <div className="row pr-0 mt-3">
                {/* Primera Columna */}
                <div className="col-12 col-lg-6">
                    {/* Código del pronostico - Code */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Código del pronostico </span>
                        </div>
                        <input
                            id="inputForecastCode"
                            className="form-control"
                            type="text"
                            disabled={action === 2}
                            maxLength={16}
                            value={model.ForecastCode || ""}
                            onChange={({ target: { value } }) => this.changeStandardField("ForecastCode", value)} />
                    </div>

                    {/* Nombre del pronostico - Name */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Nombre del pronostico </span>
                        </div>
                        <input
                            id="inputForecastName"
                            className="form-control"
                            type="text"
                            disabled={action === 2 && !editMode}
                            maxLength={100}
                            value={model.ForecastName || ""}
                            onChange={({ target: { value } }) => this.changeStandardField("ForecastName", value)} />
                    </div>
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-lg-6">
                    {/* Fecha de inicio - StartDate */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Fecha de inicio </span>
                        </div>
                        <input
                            id="inputStartDate"
                            className="form-control"
                            type="date"
                            disabled={action === 2 && !editMode}
                            value={model.ForecastStartDate || ""}
                            onChange={({ target: { value } }) => this.changeStandardField("ForecastStartDate", value)}
                            onBlur={({ target }) => this.changeDateField(1, model.ForecastStartDate, target)} />
                    </div>

                    {/* Fecha final - EndDate */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Fecha final </span>
                        </div>
                        <input
                            id="inputEndDate"
                            className="form-control"
                            type="date"
                            disabled={action === 2 && !editMode}
                            value={model.ForecastEndDate || ""}
                            onChange={({ target: { value } }) => this.changeStandardField("ForecastEndDate", value)}
                            onBlur={({ target }) => this.changeDateField(2, model.ForecastEndDate, target)} />
                    </div>

                    {/* Visualizar - ViewForm */}
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold"> Tipo de visualización </span>
                        </div>
                        <select
                            id="inputViewForm"
                            className="form-control"
                            disabled={action === 2}
                            value={model.View || ""}
                            onChange={({ target: { value } }) => this.changeTypeView(value)} >
                            <option value="D"> Días </option>
                            <option value="W"> Semanas </option>
                            <option value="M"> Meses </option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    renderEditButton = () => {
        const { action, writeAccess } = this.props;
        const { editMode, _user } = this.state;

        if (!_user || _user.FMB_Role !== 'admin1') return;

        if (action === 2 && !editMode && writeAccess) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={this.editMode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    }

    renderLines = () => {
        const {
            action,
            model
        } = this.props;

        const {
            editMode,
            searchItem
        } = this.state;

        const lines = model?.SalesForecastLines || [];

        return (
            <div className="row justify-content-around">
                <div className="col-12">
                    <div>
                        <table className="table table-scroll" style={{ fontSize: 14 }} id="bodyModal" >
                            <div
                                className="w-100"
                                aria-labelledby="nav-home-tab-Contenido"
                                style={{ minHeight: 450, maxHeight: 450 }}>
                                <table
                                    id="dataTableDocuments"
                                    className="display" >
                                    <thead className="table-header-yellow">
                                        <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                            <td style={{ maxWidth: 20 }} />
                                            <td> Artículo </td>
                                            <td> Descripción </td>
                                            <td> Almacén </td>
                                            {model.TimeInterval.map(interval => <td>{interval?.Name || ""}</td>)}
                                            {!(action === 2 && !editMode) && <th className='sticky-columns' style={{ backgroundColor: '#d2ab24' }}> Acciones </th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lines.map((line, index) =>
                                            <tr>
                                                <td> {index + 1} </td>
                                                <td> {line.ItemNo || ""} </td>
                                                <td> {line.ItemDescription || ""} </td>
                                                <td className="text-center" style={{ minWidth: 200 }}>
                                                    {!(action === 2 && !editMode) ?
                                                        <div className="input-group">
                                                            <input
                                                                id={"inputWhs-" + index}
                                                                className="form-control text-left"
                                                                type="text"
                                                                autoComplete="off"
                                                                value={line.Warehouse || ""}
                                                                onChange={({ target: { value } }) => this.changeWhsLine(index, value)}
                                                                onBlur={() => this.setState({ showPredictionsList: false })} />

                                                            <div className="input-group-append" >
                                                                <button type="button" className="btn btn-outline-warning" onClick={() => this.openWhsModal(index)}>
                                                                    <i className="fa fa-list" aria-hidden="true" size="10" />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        :
                                                        line.Warehouse || ""
                                                    }
                                                </td>
                                                {line.TimeInterval.map((interval, indexTI) =>
                                                    <>{!(action === 2 && !editMode) ?
                                                        <td style={{ minWidth: 150 }}>
                                                            <div className="input-group">
                                                                <input
                                                                    id={`"inputQty-${index}-${indexTI}`}
                                                                    className="form-control text-right"
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    value={interval.Quantity || ""}
                                                                    onChange={({ target: { value } }) => this.changeQty(index, indexTI, value)}
                                                                    onBlur={() => this.validateQty(index, indexTI, interval.Quantity)} />
                                                            </div>
                                                        </td>
                                                        :
                                                        <td className="text-right">{interval.Quantity || "0.000"}</td>
                                                    }</>
                                                )}
                                                {!(action === 2 && !editMode) &&
                                                    <td className="sticky-columns text-center" style={{ backgroundColor: '#FFF', zIndex: 3 }}>
                                                        <button type="button" class={`btn btn-outline-${!line.NewLine ? 'dark' : 'danger'}`} disabled={!line.NewLine} onClick={() => this.removeRow(index)}>
                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                        </button>
                                                    </td>
                                                }
                                            </tr>
                                        )}
                                        {!(action === 2 && !editMode) &&
                                            <tr>
                                                <td colSpan={3} className="sticky-column" style={{ backgroundColor: "#FFF", minWidth: 300, maxWidth: 300 }}>
                                                    <div className="input-group">
                                                        <input
                                                            id="itemDocumentSearch"
                                                            className="form-control"
                                                            type="text"
                                                            placeholder="Artículo"
                                                            autoComplete="off"
                                                            value={searchItem || ""}
                                                            onKeyDown={({ key }) => { if (key === "Enter") { this.openItemsModal() } }}
                                                            onChange={({ target: { value } }) => this.changeSearchItem(value)}
                                                            onBlur={() => this.setState({ showPredictionsList: false })} />
                                                        <div className="input-group-append" >
                                                            <button type="button" className="btn btn-outline-success" onClick={this.openItemsModal}>
                                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            action,
            itemsList,
            whsList,
        } = this.props;

        const {
            editMode,

            showItemsModal,
            searchItem,

            showWhsModal,

            showPredictionsList,
            predictions,
            predictionsAction,

            showWarningModal,
            warningModel,

            inputRef,
        } = this.state;


        let inputBPRect = { width: 0 , height: 0, top: 0, left: 0, bottom: 0, right: 0 };
        if (!!inputRef) {
            inputBPRect = inputRef;
        }

        return (
            <div
                id="createForecastModal"
                className="modal fade bd-example-modal-xl modal-open scroll no-select"
                role="dialog"
                data-backdrop="static"
                data-keyboard="false" >
                <div className="modal-dialog modal-xl modal-open modalOrder" role="document">
                    <div className="modal-content" id="modal-content">
                        <div className="modal-header text-white modal-style rounded-0">
                            <h4 className="modal-title" id="modal-basic-title "> Previsión ({action === 1 ? "Nuevo" : "Detalles"}) </h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true"> &times; </span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="container">
                                {this.renderHeader()}
                                {/* {this.renderEditButton()} */}
                                <hr />
                                {this.renderLines()}
                            </div>
                        </div>

                        <div className="modal-footer">
                            {action === 1 ?
                                <>
                                    <button className="btn botonCorrect" onClick={this.validateModel}> Crear </button>
                                    <button className="btn botonCerrar text-white" onClick={this.closeModal}> Cancelar </button>
                                </>
                                :
                                editMode ?
                                    <>
                                        <button className="btn botonCorrect" onClick={this.validateModel}> Guardar </button>
                                        <button className="btn botonCerrar text-white" onClick={this.cancelEditMode}> Cancelar </button>
                                    </>
                                    :
                                    <button className="btn botonCerrar text-white" onClick={this.closeModal}> Cerrar </button>
                            }
                        </div>
                    </div>
                </div>

                                
                {showPredictionsList &&
                    <SuggestionsList
                        suggestions={predictions}
                        keys={predictionsAction === "items" ?
                            [
                                { field: "ItemCode", classes: "key", styles: { minWidth: 125, maxWidth: 125} },
                                { field: "ItemName", classes: "", styles: { minWidth: 275, maxWidth: 275 } },
                            ]
                            :
                            [
                                { field: "WhsCode", classes: "key", styles: { minWidth: 50, maxWidth: 50} },
                                { field: "WhsName", classes: "", styles: { minWidth: 100, maxWidth: 100 } },
                            ]
                        }
                        action={predictionsAction === "items" ? this.addRow : this.selectWhs}
                        styles={{ maxHeight: 150 }}
                        rect={inputBPRect} />
                }

                {showItemsModal &&
                    <StandardSelectModal
                        id="selectItemsModal"
                        title="Artículos"
                        headers={itemsHeaders}
                        searchBar={searchItem}
                        data={itemsList}
                        selectAction={this.addRow}
                        actPos="start" />
                }

                {showWhsModal &&
                    <StandardSelectModal
                        id="selectWhsModal"
                        title="Selección de Almacén"
                        headers={whsHeaders}
                        data={whsList}
                        selectAction={this.selectWhs}
                        actPos="start" />
                }

                {showWarningModal &&
                    <WarningModal
                        title={warningModel.title || "Advertencia"}
                        message={warningModel.message || "¿Seguro que deseas continuar?"}
                        btnAccept={warningModel.acceptMsg || "Continuar"}
                        btnCancel={warningModel.cancelMsg || "Cancelar"}
                        size={warningModel.size || "modal-lg"}
                        accept={warningModel.accept}
                        cancel={warningModel.cancel} />
                }
            </div>
        );
    }
    //#endregion
}

export default CreateForecastModal;